// Colour configuration for the admin views.
//
// Each category owns its colour here, so a row or card keeps the same colour no
// matter where it ends up in the table. Categories without an entry fall back
// to FALLBACK_CATEGORY_COLORS by position, which is how every category was
// coloured before this config existed.
//
// Keys are the raw deployment-config category values, plus the synthetic rows
// the admin week table adds ("Total" and "Mobile").

const CATEGORY_COLORS = {
  Total: "#00C375", // green
  dangerous_waste: "#74D5F2", // blue
  "Farligt affald prototype": "#FFA94D", // orange
  Mobile: "#FF8989", // red
  mineral_wool: "#BD92F4", // purple
  plastic: "#ED9BD2", // pink
  wood: "#F3C981", // yellow
  Uncategorized: "#A8B0BC", // grey
};


// Optional per-category override for text drawn on top of the category colour.
// Undefined means "derive it from the category colour", which is what the
// admin page did for every category before.
const CATEGORY_LABEL_COLORS = {};

export const FALLBACK_CATEGORY_COLORS = [
    '#00C375',
    '#74D5F2',
    '#BD92F4',
    '#FF8989',
    '#F3C981',
    '#73FFAB',
    '#53C0FF',
    '#ED9BD2',
    '#FF89B0',
    '#90AAFF',
    '#81F3AD',
];

// The usage aggregates use "total" while the table row is titled "Total".
const normalizeCategoryKey = (category) => {
    const key = typeof category === 'string' ? category.trim() : '';
    return key === 'total' ? 'Total' : key;
};

export const getFallbackCategoryColor = (index) => {
    const position = Number.isFinite(index) ? index : 0;
    return FALLBACK_CATEGORY_COLORS[
        ((position % FALLBACK_CATEGORY_COLORS.length) + FALLBACK_CATEGORY_COLORS.length)
        % FALLBACK_CATEGORY_COLORS.length
    ];
};

/**
 * Colour for a category. `index` is only consulted for categories missing from
 * the config, so configured categories are stable across reordering.
 */
export const getCategoryColor = (category, index) => (
    CATEGORY_COLORS[normalizeCategoryKey(category)] || getFallbackCategoryColor(index)
);

export const getCategoryLabelColor = (category) => (
    CATEGORY_LABEL_COLORS[normalizeCategoryKey(category)]
);

export const hasConfiguredCategoryColor = (category) => (
    Object.prototype.hasOwnProperty.call(CATEGORY_COLORS, normalizeCategoryKey(category))
);
